module.exports = __webpack_public_path__ + "img/chromecast_background.953d846.png";